/**
 * @generated SignedSource<<bd3ea5ee415bcfdbf2e2c842c790081b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTxnsNeedsReviewInputObject = {
  needsReview: boolean;
  txnIds: ReadonlyArray<string>;
};
export type pnlCellPanel_SetTxnsNeedsReviewMutation$variables = {
  input: SetTxnsNeedsReviewInputObject;
};
export type pnlCellPanel_SetTxnsNeedsReviewMutation$data = {
  readonly setTxnsNeedsReview: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type pnlCellPanel_SetTxnsNeedsReviewMutation = {
  response: pnlCellPanel_SetTxnsNeedsReviewMutation$data;
  variables: pnlCellPanel_SetTxnsNeedsReviewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlCellPanel_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pnlCellPanel_SetTxnsNeedsReviewMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetTxnsNeedsReviewMutationPayload",
        "kind": "LinkedField",
        "name": "setTxnsNeedsReview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7370e75090af13a80bc9423cbc302f72",
    "id": null,
    "metadata": {},
    "name": "pnlCellPanel_SetTxnsNeedsReviewMutation",
    "operationKind": "mutation",
    "text": "mutation pnlCellPanel_SetTxnsNeedsReviewMutation(\n  $input: SetTxnsNeedsReviewInputObject!\n) {\n  setTxnsNeedsReview(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e7288afc0624c938d1e62dcc366f7a1";

export default node;
